import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableHeader, TableHead, TableRow, TableBody, TableCell
} from "@/components/ui/table";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter
} from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Search, Plus, Download } from "lucide-react";
import { toast } from "sonner";

export function DataToolbar({ search, setSearch, filters, onAdd, addLabel, onExport, addTestId = "data-add-button", searchTestId = "data-search-input" }) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <div className="flex items-center gap-2 px-3 py-1.5 bg-white border border-slate-200 rounded-md w-64 max-w-full">
        <Search className="h-3.5 w-3.5 text-slate-400" />
        <input
          value={search} onChange={(e) => setSearch(e.target.value)}
          placeholder="Search…" data-testid={searchTestId}
          className="bg-transparent outline-none flex-1 text-sm text-slate-700 placeholder:text-slate-400"
        />
      </div>
      {filters}
      <div className="flex-1" />
      {onExport && (
        <Button variant="outline" size="sm" onClick={onExport} data-testid="data-export-button">
          <Download className="h-3.5 w-3.5 mr-1" /> Export
        </Button>
      )}
      {onAdd && (
        <Button size="sm" className="bg-sky-900 hover:bg-sky-950" onClick={onAdd} data-testid={addTestId}>
          <Plus className="h-3.5 w-3.5 mr-1" /> {addLabel || "Add"}
        </Button>
      )}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    operational: "bg-emerald-50 text-emerald-700 border-emerald-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    closed: "bg-slate-100 text-slate-700 border-slate-200",
    open: "bg-amber-50 text-amber-700 border-amber-200",
    in_progress: "bg-sky-50 text-sky-700 border-sky-200",
    breakdown: "bg-red-50 text-red-700 border-red-200",
    maintenance: "bg-amber-50 text-amber-700 border-amber-200",
    active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    critical: "bg-red-50 text-red-700 border-red-200",
    high: "bg-amber-50 text-amber-700 border-amber-200",
    medium: "bg-sky-50 text-sky-700 border-sky-200",
    low: "bg-slate-100 text-slate-700 border-slate-200",
  };
  return (
    <span className={`inline-block px-2 py-0.5 text-xs rounded border ${map[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}>
      {String(status || "—").replace(/_/g, " ")}
    </span>
  );
}

export function PageHeader({ title, count }) {
  return (
    <div className="mb-4">
      <div className="label-cap text-slate-500">{count !== undefined ? `${count} records` : ""}</div>
      <h2 className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Chivo" }}>{title}</h2>
    </div>
  );
}
